import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AbilityService } from 'ability';
import { PermissionsEnum } from 'mbs-ui-shared';
import { SharedComputerSidepanelWrapper } from 'mbs-ui-shared/src/lib/wrappers/computer.sidepanel.wrapper';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';
import { SidepanelRouteType } from 'mbs-ui-shared@models/sidepanel';
import { filter, take } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'mbs-sidepanel-computers-wrapper-component',
  template: ''
})
export class SidepanelComputersWrapperComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private computersFacade = inject(ComputersFacade);
  private ability = inject(AbilityService);
  private computerSidepanelWrapper = inject(SharedComputerSidepanelWrapper);

  private redirectToComputers(): void {
    const queryParams = {};
    if (this.route.snapshot.queryParams['IFRAME']) {
      queryParams['IFRAME'] = this.route.snapshot.queryParams['IFRAME'];
    }
    this.router.navigate(['../'], { relativeTo: this.route, queryParams });
  }

  ngOnInit(): void {
    const computerHid = this.route.snapshot.params.hid;
    const sidepanelType: SidepanelRouteType = (this.route.snapshot.queryParams.sidepanel || '').toLowerCase();
    const activeTab = this.route.snapshot.queryParams.activeTab;

    if (computerHid && sidepanelType === SidepanelRouteType.RMM) {
      if (this.ability.cannot('read', PermissionsEnum.RmmPerAdminLicenseExists)) {
        this.redirectToComputers();
        return;
      }
      this.computersFacade
        .getByHid$(computerHid)
        .pipe(filter(Boolean), take(1), untilDestroyed(this))
        .subscribe((computer) => this.computerSidepanelWrapper.handleOpenRmmInfo(computer, activeTab));
      this.computersFacade.loadComputerByHid({ hid: computerHid });
    }
  }
}
